import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsPutReq extends EntityStaff {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_staff_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
